import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { useOptionalDescriptionColumn } from 'components/CIMSTable/common/hooks/useDescriptionColumn'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { HelpMessage } from 'utils/constants'
import { CASDispositionType } from '../DispositionTypesContext/types'
import { useDispositionTypesContext } from '../DispositionTypesContext'
import CIMSCheckbox from 'components/CIMSCheckbox'
import { useKeyedBooleans } from 'hooks/useKeyedBooleans'

export function useColumns(): CIMSColumn<CASDispositionType>[] {
  const { edit, refetch } = useDispositionTypesContext()
  const [editing, { add, remove }] = useKeyedBooleans()
  return [
    useNameColumn({ help: HelpMessage.Name, sort: { default: 'ascend' } }),
    useOptionalDescriptionColumn('Disposition Type'),
    {
      title: 'Requires Comments',
      align: 'center',
      help: HelpMessage.CAS.DispositionTypes.RequiresComments,
      render: ({ requiresComments, name, id }) => (
        <CIMSCheckbox
          checked={requiresComments}
          loading={editing(id)}
          onChange={async () => {
            add(id)
            await edit({ id, name, requiresComments: !requiresComments })
            remove(id)
            refetch()
          }}
        />
      ),
      sort: { with: 'key', key: 'requiresComments' },
      filter: { type: 'boolean', with: 'key', key: 'requiresComments' },
      width: 225,
    },
  ]
}
